export default __webpack_public_path__ + "paddle_farming_hoverb70bd2.svg";